import { useParams } from 'react-router-dom';

const useCartItemId = () => {
  const { cartItemId } = useParams<{ cartItemId: string }>();
  return cartItemId;
};

export default useCartItemId;
